var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn),expression:"showBtn"}],staticClass:"open-app-button",on:{"click":_vm.handleClick}},[_c('span',[_vm._v("App内打开")])])}
var staticRenderFns = []

export { render, staticRenderFns }